<template>
    <ul class="contact-info upper" v-if="contact != null">
        <li v-if="contact.address != null">
            <span><span style="display: inline" v-lang.address></span>:</span> {{ contact.address }}
        </li>
        <li v-if="contact.email != null">
            <span><span style="display: inline" v-lang.email></span>:</span> {{ contact.email }}. {{ contact.city }}
        </li>
        <li v-if="contact.webpage">
            <span><span style="display: inline" v-lang.web></span>:</span> {{ contact.webpage }}
        </li>
        <li v-if="contact.phone">
            <span><span style="display: inline" v-lang.phone></span>:</span> {{ contact.phone }}
        </li>
    </ul>
</template>

<script>
    import {isNull} from 'lodash';
    export default
    {
        data : function()
        {
            return {
                contact : null
            }
        },
        created : function()
        {
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( !isNull(self.$store.getters.config) )
                {
                    self.contact = self.$store.getters.config.contact;
                }
            });
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                if( !isNull(val) )
                {
                    self.contact = val.contact;
                }
            });
        },
        mounted : function()
        {
            let self = this;
            if( !isNull(this.$store.getters.config) )
            {
                self.contact = this.$store.getters.config.contact;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// contactInfo.vue?37b74513